import ServerError from '@/common/utils/errors/ServerError';
import { groupBy } from 'lodash-es';

type AccumulatedErrors = Record<string, Array<string>>

export default class MassOperationError extends ServerError {
  state: MassOperations.State;
  items: MassOperations.RejectedItem[];
  errorData?: ErrorData;

  constructor(err, state: MassOperations.State, customMessage?: string) {
    super(err.response, err.body, customMessage || err.message, `Mass operations error: ${err.name}`);
    this.stack = err.stack;
    this.state = state;
    this.items = state.rejected;
    this.errorData = err.body?.error?.data;
  }

  get accumulatedErrors(): AccumulatedErrors {
    const groupedError = groupBy(this.items, it => it.err.message);
    return Object.keys(groupedError).reduce((result, item) => {
      result[item] = groupedError[item].map(errorItem => errorItem.item?.name || errorItem.item.id);
      return result;
    }, {});
  }
}
